import type { StageDef } from './maps';
import type { MapEntity } from '../types/MapEntity.type';

const props = { density: 1, restitution: 0.35, angularVelocity: 0 };
const wall = (points: [number, number][]): MapEntity => ({
  position: { x: 0, y: 0 }, type: 'static', props: { ...props, restitution: 0.65 },
  shape: { type: 'polyline', points, rotation: 0, color: '#72d9df' },
});
function makeStage(title: string, rows: number, rotating: boolean): StageDef {
  const goalY = 14 + rows * 4;
  const entities: MapEntity[] = [
    wall([[9.25, -100], [9.25, 7], [7, 10], [7, goalY - 4], [11, goalY], [11, goalY + 3]]),
    wall([[16.5, -100], [16.5, 7], [19, 10], [19, goalY - 4], [15, goalY], [15, goalY + 3]]),
  ];
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < 4; col++) {
      entities.push({ position: { x: 8.8 + col * 2.6 + (row % 2) * 0.7, y: 12 + row * 4 },
        type: 'static', props: { ...props, restitution: 1.05 },
        shape: { type: 'circle', radius: 0.65, color: row % 2 ? '#c294ff' : '#ffab58' } });
    }
    if (rotating && row % 2 === 1) entities.push({
      position: { x: 13, y: 14 + row * 4 }, type: 'kinematic',
      props: { ...props, angularVelocity: row % 4 === 1 ? 2.2 : -2.2 },
      shape: { type: 'box', width: 2.3, height: 0.22, rotation: 0, color: '#ff7b36' },
    });
  }
  // 양쪽 회전 패들이 구슬을 다시 튕겨 보내 역전 구간을 만듭니다.
  entities.push(...[9.5, 16.5].map((x, index): MapEntity => ({
    position: { x, y: goalY - 6 }, type: 'kinematic',
    props: { ...props, restitution: 0.85, angularVelocity: index === 0 ? -2.5 : 2.5 },
    shape: { type: 'box', width: 1.6, height: 0.22, rotation: 0, color: '#ff68a1' },
  })));
  return { title, goalY, zoomY: goalY - 4, entities };
}

/** MARU 전용 트랙. 출발 위치는 공통 구슬 스폰 영역에 맞춥니다. */
export const maruStages = [
  makeStage('팡팡 핀볼', 12, true),
  makeStage('회오리 아케이드', 18, true),
  makeStage('스피드 범퍼', 8, false),
];
